import { PLATFORMS } from '../../UserSettings/constants';
// Single Searches
export const setPlatformByParserSourcePlatform = (data, rootStore) => {
    var _a, _b, _c;
    if (((_a = data.parsedData) === null || _a === void 0 ? void 0 : _a.source_platform) === 'linkedin-public') {
        rootStore.userSettings.setPlatform('linkedin-public');
    }
    if (((_b = data.parsedData) === null || _b === void 0 ? void 0 : _b.source_platform) === 'LI Recruiter Pro') {
        rootStore.userSettings.setPlatform(PLATFORMS.LINKEDIN_RECRUITER_PRO);
    }
    if (((_c = data.parsedData) === null || _c === void 0 ? void 0 : _c.source_platform) === 'LI Recruiter Lite') {
        rootStore.userSettings.setPlatform(PLATFORMS.LINKEDIN_RECRUITER_LITE);
    }
};
